export default __webpack_public_path__ + "static/media/cp_geo_kr.163c123e.svg";